export const ItemsToLinks: {[itemName: string] : string } = {
    "ufo 50": "/Ufo50", 
};
